import React from 'react';
import { useTranslation } from 'react-i18next';
import Btn from '../Btn/Btn';

type Props = {
    week: number;
    isBusy: boolean;
    onPreviousWeek: () => void;
    onNextWeek: () => void;
    onStartNachsorge: () => void;
    onResetNachsorge: () => void;
};

const ProfileWeekActions = ({
    week,
    isBusy,
    onPreviousWeek,
    onNextWeek,
    onStartNachsorge,
    onResetNachsorge,
}: Props): JSX.Element => {
    const { t } = useTranslation();

    if (week >= 15) {
        return (
            <div className="frontpage__profile-actions">
                <Btn
                    title={isBusy ? t('Resetting aftercare...') : t('Reset aftercare')}
                    variant="secondary"
                    onClick={onResetNachsorge}
                    disabled={isBusy}
                />
            </div>
        );
    }

    return (
        <div className="frontpage__profile-actions">
            <Btn
                title={t('Previous week')}
                variant="secondary"
                onClick={onPreviousWeek}
                disabled={isBusy || week <= 1}
            />
            <Btn title={t('Next week')} variant="primary" onClick={onNextWeek} disabled={isBusy || week >= 14} />
            <Btn title={t('Start aftercare')} variant="primary" onClick={onStartNachsorge} disabled={isBusy} />
        </div>
    );
};

export default ProfileWeekActions;
